/*******************************************************************************
  설  명 : 홈페이지 > 아이디찾기 > 결과
  작성자 : 송영석
  작성일 : 2020-06-08
*******************************************************************************/
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CommonService } from '@app/service/common.service';

import { ToastrService } from 'ngx-toastr';
import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

@Component({
  selector: 'app-find-id-result',
  templateUrl: './find-id-result.component.html',
  styleUrls: ['./find-id-result.component.scss']
})
export class FindIdResultComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public findResult: any;

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);

    if ( sessionStorage.getItem( 'findResult' ) === null ) {
      this.router.navigate(['/member/findid']);
    }

    this.findResult = JSON.parse( sessionStorage.getItem( 'findResult' ) );
    sessionStorage.removeItem( 'findResult' );
  }

  /*******************************************************************************
    설  명 : 데이터 로딩시 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
  }

  /*******************************************************************************
    설  명 : 로그인 폼으로 이동
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  goLink() {
    this.router.navigate(['/member/login']);
  }
}
